import settingsEnums from '../../../../helpers/enums/settings'
import { IPlayerData } from '../../../../helpers/data/player'

const syncScore = (player: IPlayerData) => player.score
const ownPacedScore = (player: IPlayerData, activities: any[], currentActivityUID: string) => {
	let score = 0
	let index = 0
	while (index < activities.length) {
		if (activities[index].uid === currentActivityUID || !player.history[index]) {
			break
		}
		score += player.history[index].score
		index += 1
	}

	return score
}

const modeResolvers = {
	[settingsEnums.SETTING_GAME_MODE_SYNC]: syncScore,
	[settingsEnums.SETTING_GAME_MODE_OWN_PACED]: ownPacedScore,
}

const playerScore = (
	player: IPlayerData,
	activities: any[],
	currentActivityUID: string,
	gameMode: number = settingsEnums.SETTING_GAME_MODE_SYNC
) => {
	return modeResolvers[gameMode](player, activities, currentActivityUID)
}

export default playerScore
